<script>
  import { getStatusAction } from '@utils/string'
  import { checkVisibility } from '@utils/modal'
  export default {
    props: {
      action: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: 'negative-action-confirm-modal',
      },
    },
    data() {
      return {
        error: '',
        note: '',
      }
    },
    computed:{
      modalElementId(){
        return `${this.id}___FB_modal_outer_`
      }
    },
    methods: {
      checkVisibility,
      getStatusAction,
      tryToOk (bvModalEvt) {
        this.error = ''
        if (!this.note.trim().length) {
          this.error = 'Comments are required.'
          return bvModalEvt(false)
        }
        this.$emit('ok', {
          content: this.note,
          title: this.action,
        })
      },
    },
  }
</script>

<template>
  <FabricModal
    :id="id"
    centered
    body-class="p-0 custom-modal-body"
    content-class="custom-modal-content"
    modal-class="delete-modal-content"
    ok-variant="danger"
    ok-title="Yes, I want"
    size="md"
    hide-header
    @ok="tryToOk"
    @shown="checkVisibility(modalElementId)"
  >
    <template v-slot:modal-body>
      <div class="modal-body p-0">
        <div class="custom-border-header px-4 pt-3">
          <div class="custom-border-header-content text-primary pb-3" style="text-transform: capitalize">{{ getStatusAction(action) }}</div>
        </div>
        <div class="px-4 py-2">Are you sure you want to {{ getStatusAction(action) }} this document? Please help me to enter your reason.</div>
        <div class="px-4">
          <div class="form-group">
            <label for="">Comments</label>
            <textarea v-model="note" class="form-control" rows="4"></textarea>
            <p v-if="error" class="text-danger">{{ error }}</p>
          </div>
        </div>
      </div>
    </template>
  </FabricModal>
</template>
